import { useState, useMemo, useCallback, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faX, faTrash } from "@fortawesome/free-solid-svg-icons";
import "./componentsCss/CancelModal.css";

const CancelScheduleModal = ({ schedule, patient, onClose, onConfirm }) => {
  const cancellable = useMemo(() => {
    const validProcedures = Array.isArray(schedule?.procedures)
      ? schedule.procedures
          .filter((p) => !p.cancel && !p.confirmed) // ← filtrando apenas não cancelados ou confirmados
          .map((p, idx) => ({
            ...p,
            _uid: p.id ?? p.procedure_id ?? `${schedule.date}-${idx}`,
          }))
      : [];

    return validProcedures;
  }, [schedule]);

  const [selectedIds, setSelectedIds] = useState([]);
  const [reason, setReason] = useState("");
  const isAllSelected = selectedIds.length === cancellable.length;

  const toggleSelect = useCallback((uid) => {
    setSelectedIds((prev) =>
      prev.includes(uid) ? prev.filter((id) => id !== uid) : [...prev, uid]
    );
  }, []);

  const toggleSelectAll = () => {
    setSelectedIds(isAllSelected ? [] : cancellable.map((p) => p._uid));
  };

  const handleConfirm = () => {
    if (onConfirm) {
      const proceduresToCancel = cancellable
        .filter((p) => selectedIds.includes(p._uid))
        .map((p) => ({
          procedure_id: p.procedure_id ?? p.id,
          scheduling_id: p.scheduling_id,
          requisition_id_foreign: p.requisition_id_foreign,
        }));

      onConfirm({
        canceledProcedures: proceduresToCancel,
        canceledSchedules: Array.from(
          new Set(cancellable.map((p) => p.scheduling_id))
        ),
        requisition_id_foreign: Array.from(
          new Set(cancellable.map((p) => p.requisition_id_foreign))
        ),
        reason: reason.trim(),
      });
    }
    onClose();
  };

  useEffect(() => {
    console.log("IDs selecionados: ", selectedIds);
    console.log("Motivo do cancelamento: ", reason);
    console.log("Agendamento selecionado: ", schedule);
    console.log("Paciente selecionado: ", patient);
    console.log(
      "Procedimentos selecionados: ",
      Array.from(new Set(cancellable.map((p) => p.scheduling_id)))
    );
    console.log(
      "Requisições selecionadas: ",
      Array.from(new Set(cancellable.map((p) => p.requisition_id_foreign)))
    );
  }, [selectedIds, reason, schedule, patient]);

  return (
    <div className="modal-overlay">
      <div
        className="reschedule-modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="cancel-title">
        <div className="modal-header">
          <h2 id="cancel-title">Cancelar Procedimentos</h2>

          {cancellable.length > 1 && (
            <label className="select-all">
              <input
                type="checkbox"
                checked={isAllSelected}
                onChange={toggleSelectAll}
              />
              Selecionar todos
            </label>
          )}

          <button
            className="close-button"
            aria-label="Fechar"
            onClick={onClose}>
            <FontAwesomeIcon icon={faX} />
          </button>
        </div>

        <div className="modal-body">
          <p>
            <strong>Paciente:</strong> {patient?.name}
          </p>
          <p>
            <strong>Médico:</strong> {schedule?.doctorName || "Não informado"}
          </p>

          {cancellable.length === 0 ? (
            <p className="text-muted" style={{ textAlign: "center" }}>
              Nenhum procedimento disponível para cancelamento.
            </p>
          ) : (
            <>
              <div className="procedure-list">
                {cancellable.map((proc) => (
                  <label
                    key={proc._uid}
                    className="procedure-item"
                    style={{ cursor: "pointer" }}>
                    <input
                      type="checkbox"
                      checked={selectedIds.includes(proc._uid)}
                      onChange={() => toggleSelect(proc._uid)}
                      style={{ marginRight: "0.75rem" }}
                    />
                    <div>
                      <h4 style={{ marginBottom: 4 }}>
                        {proc.procedure_name ??
                          `Procedimento ${proc.procedure_id}`}
                      </h4>
                      <small>{schedule.date || "Data não informada"}</small>
                    </div>
                  </label>
                ))}
              </div>

              <div className="form-group" style={{ marginTop: "1.25rem" }}>
                <label htmlFor="cancel-reason">
                  Motivo do cancelamento (opcional)
                </label>
                <textarea
                  id="cancel-reason"
                  rows={3}
                  value={reason}
                  onChange={(e) => setReason(e.target.value)}
                  placeholder="Descreva brevemente o motivo"
                />
              </div>
            </>
          )}
        </div>

        <div className="modal-footer">
          <button className="cancel-button" onClick={onClose}>
            Voltar
          </button>
          <button
            className="danger-button"
            disabled={selectedIds.length === 0}
            onClick={handleConfirm}>
            <FontAwesomeIcon icon={faTrash} /> Confirmar Cancelamento
          </button>
        </div>
      </div>
    </div>
  );
};

export default CancelScheduleModal;
